export const year = Object.freeze({
  id: 1,
  name: 'Año(s)',
});
export const month = Object.freeze({
  id: 2,
  name: 'Mes(es)',
});

export const options = Object.freeze({ year, month });
export default [year, month];
